import { ThunkAction } from "redux-thunk";
import { Action } from "redux";

import { RootState } from "app/redux/reducer";
import { PlaceService } from "./service";
import { showMessage, toggleConfirmDialog, toggleLoader } from "app/redux/system/actions";
import { initialPageData } from "app/redux/page/actions";
import { MessageType } from "app/redux/system/types";
import { IPlace } from "./types";
import { HttpStatusCode, IList, IListFilter } from "app/shared";
import { mapPlaceFromEntity, mapPlaceFromModel } from "./mapping";

type ThunkResult<R> = ThunkAction<R, RootState, {}, Action>;

export function getPlace(id: string, language?: string, notFill?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new PlaceService();
        dispatch(toggleLoader());
        const response = await service.getPlace(id, language || getState().system.defaultLanguage);
        dispatch(toggleLoader());

        if (response.status === HttpStatusCode.OK) {
            const mapped = mapPlaceFromEntity(response.data.attributes["place"] || {});

            if (!notFill) {
                dispatch(initialPageData<IPlace>(mapped));
            }
            return mapped;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function getPlaceByLanguage(pageData: IPlace, language: string, isOverride?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new PlaceService();
        dispatch(toggleLoader());
        const response = await service.getPlace(pageData.id as string, isOverride ? getState().system.defaultLanguage : language);
        if (response.status === HttpStatusCode.OK) {
            const mapped = mapPlaceFromEntity(response.data.attributes["place"] || {});
            const data = { ...mapped, language: language, id: isOverride ? pageData.id : mapped.id };
            dispatch(initialPageData<IPlace>(data));
            if (isOverride) {
                dispatch(updatePlace(data));
            }
            dispatch(toggleLoader());
            return true;
        }
        else {
            dispatch(toggleConfirmDialog(true, {
                title: "Uyarı!",
                text: `Geçerli dil'e (${language}) ait bir kayıt bulunamadı. Varsayılan dil üzerinden seçtiğiniz dile göre kayıt oluşturulsun mu?`,
                button: {
                    approveText: "Varsayılan Dil'den Oluştur"
                },
                callback: () => {
                    dispatch(createPlace({ ...pageData, id: "", title: `${pageData.title} (${language.toUpperCase()})`, language })).then(res => {
                        if (res) {
                            dispatch(getPlace(res.id as string, language));
                        }
                    });
                    return true;
                }
            }))
        }
        dispatch(toggleLoader());
        return false;
    };
}


export function getPlaces(options: IListFilter): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new PlaceService();
        dispatch(toggleLoader());
        const response = await service.getPlaces(options);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapPlaceFromEntity(item)
            );
            dispatch(initialPageData<IList<IPlace[]>>({
                list: mapped,
                pageSize: response.data.attributes.pageSize,
                totalCount: response.data.attributes.total,
                pageCount: Math.ceil(response.data.attributes.total / response.data.attributes.pageSize)
            }));
            return true;
        }
        return false;
    };
}

export function getPlacesForLocal(language: string): ThunkResult<Promise<IPlace[]>> {
    return async () => {
        const service = new PlaceService();
        const response = await service.getPlaces({ page: 1, pageSize: 100, descending: false, language });
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapPlaceFromEntity(item)
            );
            return mapped;
        }
        return [];
    };
}

export function createPlace(request: IPlace): ThunkResult<Promise<IPlace | null>> {
    return async (dispatch) => {
        const service = new PlaceService();
        dispatch(toggleLoader());
        const response = await service.createPlace(mapPlaceFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return mapPlaceFromEntity(response.data.attributes["place"] || {});
        }
        return null;
    };
}

export function updatePlace(request: IPlace): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new PlaceService();
        dispatch(toggleLoader());
        const response = await service.updatePlace(mapPlaceFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        return false;
    };
}

export function deletePlace(id: string): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new PlaceService();
        dispatch(toggleLoader());
        const response = await service.deletePlace(id);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}